import React from 'react';
import { Grid } from '@material-ui/core';
import { IButton } from '../../common/interfaces/IButton';
import Keypad from '../../keypad/components/keypad';

interface KeypadColumnProps {
  headerText: string;
  keypadSubmitButton: IButton;
  isKeypadVisible: boolean;
  isLeftHanded: boolean;
  keyboardId: string;
  keypadTestIdPrefix?: string;
  formatter?: any;
  disableQuantity?: boolean;
}

const KeypadColumn = ({
  headerText,
  keypadSubmitButton,
  isKeypadVisible,
  isLeftHanded,
  keyboardId,
  keypadTestIdPrefix,
  formatter,
  disableQuantity,
}: KeypadColumnProps): JSX.Element => {
  return (
    <Grid item xs={3} style={{ alignSelf: 'flex-end' }}>
      <Grid
        item
        style={{ paddingBottom: '1vh', marginLeft: isLeftHanded ? '3vh' : '0vh' }}
        className={`fullHeight`}
      >
        <Keypad
          submitButton={keypadSubmitButton}
          visible={isKeypadVisible}
          topLabelText={headerText || ''}
          noInputField={true}
          keyboardId={keyboardId}
          minHeight={'4vh'}
          keypadTestIdPrefix={keypadTestIdPrefix || ''}
          formatter={formatter}
          replaceDecimalInput
          disableManualWeight={true}
          disableQuantity={disableQuantity}
        />
      </Grid>
    </Grid>
  );
};

export default KeypadColumn;
